export enum MediaQuery {
  Small = 320,
  Medium = 600,
  Large = 1024,
}
